import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatBytes } from "@air/utilities";
import Image from "next/image";
import pluralize from "pluralize";
import { useSelector } from "react-redux";
import { contentCollectionUploadedClipsSelector } from "../redux/selector";
import { ContentCollectionSidebarSeparator } from "./ContentCollectionSidebarSeparator";
export const ContentCollectionCompletedUploads = ()=>{
    const uploadedClips = useSelector(contentCollectionUploadedClipsSelector);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col gap-4 md:gap-6",
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "text-center text-24 font-semibold text-grey-12 md:hidden",
                children: "Your upload is complete!"
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: "text-center text-14 font-semibold text-grey-11 md:text-left",
                children: [
                    pluralize("item", uploadedClips.length, true),
                    " have been successfully submitted."
                ]
            }),
            /*#__PURE__*/ _jsx(ContentCollectionSidebarSeparator, {
                className: "block md:hidden"
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "flex flex-col gap-4 opacity-60",
                children: uploadedClips.map((clip)=>{
                    return /*#__PURE__*/ _jsxs("li", {
                        className: "flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "relative size-10 rounded bg-grey-5",
                                children: clip.assets.image ? /*#__PURE__*/ _jsx(Image, {
                                    alt: clip.title || "",
                                    fill: true,
                                    className: "object-cover",
                                    src: clip.assets.image,
                                    style: {
                                        objectFit: "cover"
                                    }
                                }) : /**
                 * @TODO - Update this with clip extension preview once that's moved to it's own package
                 */ null
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex flex-col gap-0.5",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "truncate text-14 font-semibold text-grey-12",
                                        children: clip.title
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "text-12 text-grey-10",
                                        children: formatBytes(clip.size)
                                    })
                                ]
                            })
                        ]
                    }, clip.id);
                })
            })
        ]
    });
};
